<template>
  <div class="home">
    <div v-if="actived == 1">
      <home></home>
    </div>
    <div v-if="actived == 2">
      <order></order>
    </div>
    <div v-if="actived == 3">
      <my></my>
    </div>
    <div class="tab-wrap">
      <div
        v-for="item in tabList"
        :key="item.id"
        class="tab-item"
        :class="{ actived: actived == item.id }"
        @click="onActivated(item)"
      >
        <img
          class="icon"
          :src="actived == item.id ? item.activeIcon : item.icon"
          alt=""
        />
        <span class="tip"> {{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { tabList } from "@/utils/const";
import home from "@/views/home/index.vue";
import my from "@/views/my/index.vue";
import order from "@/views/orderList/index.vue";
import { preCheck } from "@/api/index";
import { setLocalStorageData } from "@/common/index.js";

export default {
  components: {
    home,
    my,
    order,
  },
  data() {
    return {
      tabList,
    };
  },
  async mounted() {
    // 贷前检测
    const preCheckRes = await preCheck({});
    this.$store.commit("setPreCheckData", preCheckRes);
    setLocalStorageData("preCheckData", preCheckRes);
  },
  methods: {
    onActivated(item) {
      localStorage.setItem("actived", item.id);
      this.$store.commit("setActivedTab", item.id);
    },
  },
  computed:{
    actived(){
      return this.$store.state.activedTab;
    }
  },
  watch: {
    actived(newVal) {
      if (newVal == 2) {
        // 2. 动态修改全局 CSS 变量
        document.documentElement?.style?.setProperty?.(
          "--status-bar-bg",
          "#F24334",
        );
      }else if(newVal == 1){
         document.documentElement?.style?.setProperty?.(
          "--status-bar-bg",
          "#feddda",
        );
      }
      else{
         document.documentElement?.style?.setProperty?.(
          "--status-bar-bg",
          "#fff2ea",
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tab-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-top: 8px;
  box-sizing: border-box;
  background-color: #ffffff; /* 确保背景色能够覆盖安全区 */
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    font-size: 11px;

    .icon {
      width: 20px;
      height: 20px;
    }
  }
  .actived{
    color: #F24334;
  }
}
.kind-tips {
  position: absolute;
  bottom: 5.5%;
  color: #999999;
  font-size: 10px;
  background: #f4f4f4;
  padding: 20px 0px;
  .text {
    padding: 0 16px;
  }
}
</style>
